export default __webpack_public_path__ + "static/media/Morphism NYC inverted.35f8e731.png";